var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-questionId":_vm.questionId}},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.question))])])
}
var staticRenderFns = []

export { render, staticRenderFns }